import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "skill-name" }
const _hoisted_2 = { class: "skill-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GenericButton = _resolveComponent("GenericButton")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_GenericSubPanel = _resolveComponent("GenericSubPanel")!
  const _component_GenericPanel = _resolveComponent("GenericPanel")!

  return (_openBlock(), _createBlock(_component_GenericPanel, {
    "class-name": "skills-container",
    title: "SKILLS",
    "show-info": ['Default', 'Skills']
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.Skills), (skill) => {
        return (_openBlock(), _createElementBlock("div", {
          key: skill,
          class: _normalizeClass(["skill-wrapper", {
        'text-disabled': skill === 'Scavenging',
        'text-tagged': _ctx.getSkillData(skill).tagged
      }])
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_GenericButton, {
              text: _ctx.Skills[skill].name,
              variant: "text",
              class: "item-hover",
              onMouseover: ($event: any) => (_ctx.showInfo('Skills', skill)),
              onClick: ($event: any) => (_ctx.tagSkill(skill))
            }, null, 8, ["text", "onMouseover", "onClick"])
          ]),
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.getSkillData(skill).value), 1),
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "skill-percent" }, " % ", -1)),
          _createVNode(_component_Checkbox, {
            class: _normalizeClass({
          hidden: skill === 'Scavenging'
        }),
            onToggle: ($event: any) => (_ctx.tagSkill(skill)),
            checked: _ctx.getSkillData(skill).tagged,
            onClick: ($event: any) => (_ctx.showInfo('Skills', skill))
          }, null, 8, ["class", "onToggle", "checked", "onClick"])
        ], 2))
      }), 128)),
      _createVNode(_component_GenericSubPanel, { class: "sub-panel" }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["tag-counter", _ctx.successClass])
          }, _toDisplayString(`TAG 3 SKILLS: ${_ctx.taggedSkills}/3`), 3)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}